var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbleBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 74,
    viewBox: "0 0 111 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_884_3088)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1692 58.9613C56.0917 60.3462 54.3447 60.3462 53.2671 58.9613L50.8741 56.0359C50.3787 55.4304 50.131 55.1276 49.8257 54.9098C49.5552 54.7168 49.2526 54.5734 48.9319 54.4862C48.57 54.3878 48.1788 54.3878 47.3964 54.3878H19.8382C16.0695 54.3878 14.7029 53.997 13.3252 53.2634C11.9474 52.5297 10.8661 51.453 10.1292 50.0811C9.3924 48.7092 9 47.3485 9 43.5959V15.7919C9 12.0393 9.3924 10.6785 10.1292 9.30664C10.8661 7.93476 11.9474 6.8581 13.3252 6.12441C14.7029 5.39072 16.0695 5 19.8382 5H91.1618C94.9305 5 96.2971 5.39072 97.6748 6.12441C99.0526 6.8581 100.134 7.93476 100.871 9.30664C101.608 10.6785 102 12.0393 102 15.7919V43.5959C102 47.3485 101.608 48.7092 100.871 50.0811C100.134 51.453 99.0526 52.5297 97.6748 53.2634C96.2971 53.997 94.9305 54.3878 91.1618 54.3878H65.1693C63.6045 54.3878 62.8222 54.3878 62.0984 54.5846C61.4571 54.759 60.8518 55.0459 60.3108 55.4318C59.7001 55.8674 59.2048 56.473 58.214 57.6841L57.1692 58.9613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_884_3088",
    x: 0.0139465,
    y: 0.506973,
    width: 110.972,
    height: 72.9721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49303
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.49303
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_884_3088"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49303
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24651
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow_884_3088",
    result: "effect2_dropShadow_884_3088"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_884_3088",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleBox);
export default __webpack_public_path__ + "static/media/bubbleBox.d909d7fecf9c278a7f1e7f2d327b1701.svg";
export { ForwardRef as ReactComponent };